import { render, staticRenderFns } from "./SalesNotes.vue?vue&type=template&id=9253e864&scoped=true&"
import script from "./SalesNotes.vue?vue&type=script&lang=js&"
export * from "./SalesNotes.vue?vue&type=script&lang=js&"
import style0 from "./SalesNotes.vue?vue&type=style&index=0&id=9253e864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9253e864",
  null
  
)

export default component.exports